<template>
        <div class="accordion-group">
            <h2 class="accordion-header select-vehicle-header" data-state="open" tabindex="0" @click="showCars = !showCars" :class="{'accordion-header-complete': $store.state.form.car.model}"><span v-if="$store.state.form.car.model">{{$store.state.form.car.model.name}}</span><span v-else v-html="$store.state.texts.car.model.title"></span></h2>
            <transition name="show-cars">
                <div v-if="!$store.state.form.car.model || showCars" class="accordion-panel select-vehicle-content showCars" data-state="closed">
                    <div class="vehicle-dropdown">
                        <label for="range-type-list">Ponudba vozil</label>
                        <span class="custom-selectbox custom-selectbox-text">
                            <span class="selectedValue">KATALOG</span>
                            <span class="is-visually-hidden">Izberite za prikaz</span>
                            <select name="range-type-list" id="range-type-list">
                                <option value="KATALOG">KATALOG</option>
                                <option value="VSA VOZILA">VSA VOZILA</option>
                            </select>
                            </span>
                    </div>
                    <ul class="vehicle-categories">
                        <li class="vehicle-in-category testttt " v-for="car in $store.state.dropdowns.models" v-bind:key="car.name" @click="selectCar(car)">
                            <label>
                                <input class="vehicle-in-category-radio-button" name="selectedVehicle" title="Juke"
                                type="radio">
                                <span class="vehicle-in-category-wrapper">
                                    <span class="c_029-1">
                                        <span class="picture-element " data-alt="">
                                            <span data-src="//www.nissan-cdn.net/content/dam/Nissan/slovenia/vehicles/juke/f15/versiontobemodified/packshots/Desktop_Juke.png.ximg.l_3_m.smart.png"
                                            data-density="1" class="analytics-target">
                                                <img alt="" title="" class=" " :src="car.image">
                                            </span>
                                            <noscript>
                                                <img alt="" :src="car.image"
                                                />
                                            </noscript>
                                        </span>
                                    </span>
                                    <span class="vehicle-in-category-name">
                                        <span class="vehicle-in-category-name-inner" v-html="car.name"></span>
                                    </span>
                                </span>
                            </label>
                        </li>
                    </ul>
                </div>
            </transition>
            </div>
</template>
<script>
export default {
  data () {
    return {
      showCars: false
    }
  },
  created () {
    if (this.$route.query.modelCode) {
      var model = this.$store.state.dropdowns.models.filter((el) => {
        return el.value === this.$route.query.modelCode
      })

      if (model.length > 0) {
        this.$store.state.form.car.model = model[0]
        this.showCars = false;

        if (!this.dws) {
            this.$store.state.form.dealer = null
        }
      }
    }

    if (this.$route.query.dws) {
      this.dws = true
    }
  },
  methods: {
    selectCar (model) {
      this.showCars = false
      this.$store.state.form.car.model = model
      if (!this.dws) {
        this.$store.state.form.dealer = null
      }
    }
  }
}
</script>
<style scoped>
    /* TRANSITIONS */
    .show-cars-enter {
        display: none;
        overflow: hidden;
        height: 20.4492px;
        padding-top: 0.899525px;
        margin-top: 0px;
        padding-bottom: 0px;
        margin-bottom: 0px;
    }
    .show-cars-enter-to {
        display: block;
        overflow: hidden;
        height: 309.313px;
        padding-top: 13.6021px;
        margin-top: 0px;
        padding-bottom: 0px;
        margin-bottom: 0px;
    }
    .show-cars-enter-active {
        transition: height, padding-top 200ms ease-out;
    }
</style>



// WEBPACK FOOTER //
// src/components/form/CarPicker.vue